import globals from '#utilities/js/ea/globals.js'
import { ctrlButton } from './ui.js'
import { validAction } from './valid.js'

const done = () => {
  const doneButton = ctrlButton('done')
  if (doneButton)
    validAction(doneButton)
}

export default () => {
  done()
}


globals.ea_meet_done = done

